let tpl = `
<ul>
    <% if(hnNavigationBar) { %>
        <% for(i=0; i<hnNavigationBar.length; i++) { %>
            <li clstag="firsttype|keycount|jdworldwide|nav<%=i+1%>">
                <a target="_blank" class="rNav rNav-<%=hnNavigationBar[i].navId%>" nav-idx="<%=hnNavigationBar[i].navIdx%>" href="<%=hnNavigationBar[i].linkText%>">
                    <% if(hnNavigationBar[i].text && hnNavigationBar[i].text != "") { %>
                        <%=hnNavigationBar[i].text%>
                        <% if(hnNavigationBar[i].imgLogo) { %> 
                            <img src="<%=hnNavigationBar[i].imgLogo%>" class="nav-icon"> 
                        <% } %>
                    <% } else { %>
                        <img src="<%=hnNavigationBar[i].actImg%>" class="nav-logo">
                    <% } %>
                </a>
            </li>
        <% } %>
    <% } %>
</ul>
`;
exports.tpl = tpl;


// WEBPACK FOOTER //
// ./src/js/template/navItemV2.js